/**
 * BiomesConfig — single visible toggle surface for the /biomes URL.
 *
 * `/biomes` boots the **Biome Nexus** showcase hub (`data/levels/biome_nexus.json`):
 * a flat concourse whose six ungated tour pads warp out to the biome example
 * maps (volcano / frozen lake / crystal caverns / sunken ruins / ancient temple
 * / coil undercroft). It's the "vibe gallery" — hop in, soak in each biome's
 * atmosphere regardless of character level, hop back via the in-session
 * "Biome Nexus" return button.
 *
 * Ungating lives in the MAP DATA, not here: each pad in biome_nexus.json sets
 * `bypassZoneGate: true`, which forces the portal ungated (see
 * shared/logic/portalGate.ts). Real progression maps never set it, so the live
 * world's level gating is untouched.
 *
 * Wiring (same path as the other mode configs):
 *   - applyModeUrlCoercion.ts → coerceModeUrl injects ?map=biome_nexus + preset
 *   - HomeModePicker.tsx       → the "Biome Nexus" card navigates here
 *   - main.tsx                 → /biomes route renders <App/>
 *
 * No bots, no PvP — it's a calm gallery. preset 'live-lobby' = clean viewport,
 * dev UI off, nameplates on.
 */

export const BIOMES_CONFIG = {
  resetOnLoad: true,
  defaultClass: 'mage' as const,
  preset: 'live-lobby' as const,
  skipSplash: true,
  skipLogin: true,
} as const;
